import { render } from "./HiImage.vue?vue&type=template&id=37af4392"
import script from "./HiImage.vue?vue&type=script&lang=js"
export * from "./HiImage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__